export enum ThemeMode {
  System = "system",
  Light = "light",
  Dark = "dark",
}

export enum ThemeColor {
  Green = "green",
  Red = "red",
  Yellow = "yellow",
}

export interface ThemeSettings {
  mode: ThemeMode;
  color: ThemeColor;
}

export interface UIPreferences {
  showQuickDeposit: boolean;
}

export interface UserPreferences {
  userId: number;
  themeColor: ThemeColor;
  themeMode: ThemeMode;
  showQuickDeposit: boolean;
  onboardingSetupDismissedAt: string | null;
  /** When Zero's one-time dark default was applied for this user; null = not yet. */
  zeroDarkDefaultAppliedAt: string | null;
}
